// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5736ca2a]:export {\n  sideBarWidth: 210px;\n  appHeaderHeight: 60px;\n  interval: 16px;\n}\n.news-panel[data-v-5736ca2a] {\n  padding: 24px 0;\n}\n.news-panel__footer[data-v-5736ca2a] {\n  text-align: right;\n  padding-top: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
